// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__-2I3O","productName":"Table_productName__e9vIT"};